function debounce(callback, ms) {
    var timeout;
    return function () {
        if (!timeout) {
            ms = 0;
        }
        var args = arguments;
        var context = this;
        clearTimeout(timeout);
        timeout = setTimeout(function () {
            callback.apply(context, args);
        }, ms);
    };
}

searchSuggestionHandler = debounce(function (e) {
    let query = e.target.value;

    searchCurrentQuery.innerHTML = '<mark>' + query + '</mark>';
    searchCurrentQuery.href = '/search?q=' + encodeURIComponent(query);

    if (query.length == 0) {
        searchSuggestionProducts.innerHTML = "";
        searchSuggestionQueries.innerHTML = "";
        searchSuggestionBox.classList.remove('is-active');

    }


    if (query.length < 3) {
        searchSuggestionQueries.innerHTML = "";
        return;
    }


    fetch(window.Shopify.routes.root + "search/suggest.json?q=" + encodeURIComponent(query) + "&resources[type]=product,query")
        .then((response) => response.json())
        .then((suggestions) => {
            const productSuggestions = suggestions.resources.results.products;
            const querySuggestions = suggestions.resources.results.queries;
            searchSuggestionBox.classList.add('is-active');

            if (productSuggestions.length > 0) {
                searchSuggestionProducts.innerHTML = "";
                productSuggestions.forEach(product => {
                    let prod = document.createElement('div');


                    let img = product.image;
                    if (img == null) {
                        img = '/cdn/shop/t/4/assets/placeholder.svg?v';
                    }


                    prod.innerHTML = '<a href="' + product.url + (product.url.includes('?') ? '&' : '?') + 'int_src=search_suggestions' + '">' + '<img src="' + img + '&width=200" class="searchSuggestionThumb"><div>' + product.title + '</div></a>';
                    searchSuggestionProducts.append(prod);
                });
            } else {
                searchSuggestionProducts.innerHTML = ''
            }

            searchSuggestionProducts.innerHTML += '<div><a href="/search?&type=product&q='+ encodeURIComponent(query) +'"><span class="searchSuggestionThumb placeholder"></span> <div>See all results →</div></a></div>';


            searchSuggestionQueries.innerHTML = "";
            querySuggestions.forEach(query => {
                let q = document.createElement('div');
                q.innerHTML = '<a href="' + query.url + '">' + query.styled_text + "</a>";
                searchSuggestionQueries.append(q);

                if (searchCurrentQuery.innerText == query.text) {
                    searchCurrentQuery.innerHTML = '';
                }

            });



        }
        );
}, 150);


function closeSearchSuggestionHandler() {
    setTimeout(() => {
        if (document.activeElement === document.getElementById('searchSuggestionBox')) {
            return;
        };
        if (document.getElementById('searchSuggestionBox').contains(document.activeElement)) {
            return;
        };
        if (document.activeElement === document.getElementById('search-field')) {
            return;
        };

        searchSuggestionProducts.innerHTML = "";
        searchSuggestionQueries.innerHTML = "";
        searchSuggestionBox.classList.remove('is-active');

    }, 100);
}

document.getElementById('search-field').addEventListener('keyup', searchSuggestionHandler);
document.getElementById('search-field').addEventListener('blur', closeSearchSuggestionHandler)
document.getElementById('searchSuggestionBox').addEventListener('blur', closeSearchSuggestionHandler)
